import * as _ from 'lodash';
import * as React from 'react';
import { Button } from '../../components/ui/Button';
import { MaterialIcon } from '../../components/ui/MaterialIcon';
import { Modal, ModalContent, ModalFooter } from '../../components/ui/Modal';
import { HttpRequest } from '../../util/http';
import { StatusEndpoint, StatusTypesEndpoint } from '../../util/http/endpoints';
import { IStatus, IStatusTypes } from './interfaces';

interface ICoachingFormStatusProps {
  abbr_survey: string
  id: string
  statuses: IStatus[]
  randomNumber: number
}

interface ICoachingFormStatusState {
  statuses: IStatus[]
  openModal: boolean
  statusTypes: IStatusTypes[]
  newStatus: {
    actionTaken: string
    resolutionStatus: number
  }
}

export class CoachingFormStatus extends React.Component<ICoachingFormStatusProps, ICoachingFormStatusState> {

  static getDerivedStateFromProps(nextProps, prevState) {
    let statuses = prevState.statuses

    if (nextProps.statuses && prevState.statuses) {
      if (nextProps.statuses.length !== prevState.statuses.length) {
        statuses = nextProps.statuses
      } else {
        if (nextProps.statuses.length > 0) {
          for (let i = 0; i < nextProps.statuses.length; i++) {
            if (nextProps.statuses[i].actionTaken !== prevState.statuses[i].actionTaken) {
              statuses = nextProps.statuses
            }
          }
        }
      }
    }

    return {
      statuses,
      openModal: prevState.openModal,
      statusTypes: prevState.statusTypes,
      newStatus: prevState.newStatus
    }
  }

  state: ICoachingFormStatusState = {
    openModal: false,
    newStatus: {
      actionTaken: '',
      resolutionStatus: 0
    },
    statuses: [],
    statusTypes: []
  }

  constructor(props) {
    super(props)
    this.state.statuses = props.statuses
    this.loadStatuses()
    this.loadStatusTypes()
  }

  componentDidMount() {
    window.addEventListener('openAddStatus', (e) => {
      const openModal = true
      this.setState({ openModal })
    })
  }

  loadStatuses() {
    const { abbr_survey, id } = this.props
    const params = { abbr_survey, id }

    HttpRequest.fetch<IStatus[]>('/scripts/action_alerts/action_alert/getActionItemStatusHistory?abbr_survey=' + abbr_survey + '&id=' + id, { params })
      .then((statuses) => {
        statuses.map((s) => {
          s.date = new Date(s.date).toLocaleDateString() + ', ' + new Date(s.date).toLocaleTimeString()
          return s
        })
        this.setState({ statuses })
      })
  }

  loadStatusTypes() {
    HttpRequest.fetch<IStatusTypes[]>(StatusTypesEndpoint)
      .then((statusTypes) => this.setState({ statusTypes }))
  }

  updateModalState(openModal: boolean) {
    this.setState({ openModal })
  }

  static NO_ACTION_NEEDED = 'No action needed'
  updateNewStatus<K extends keyof ICoachingFormStatusState['newStatus']>(attr: K, value: IStatus[K]) {
    const { newStatus } = this.state

    if (attr === 'resolutionStatus' && value === '4' && (newStatus.actionTaken === '' || newStatus.actionTaken === undefined)) {
      newStatus.actionTaken = CoachingFormStatus.NO_ACTION_NEEDED
    }

    if (attr === 'resolutionStatus' && value !== '4' && newStatus.actionTaken === CoachingFormStatus.NO_ACTION_NEEDED) {
      newStatus.actionTaken = ''
    }

    if (attr === 'actionTaken' && newStatus.resolutionStatus == 4 && value.length > CoachingFormStatus.NO_ACTION_NEEDED.length) {
      value = value.replace(CoachingFormStatus.NO_ACTION_NEEDED, '')
    }

    // @ts-ignore
    newStatus[attr] = value

    this.setState({ newStatus })
  }

  addResolutionStatus(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault()

    const { newStatus } = this.state
    const method = 'POST'
    const body = JSON.stringify(newStatus)
    const { abbr_survey, id } = this.props
    const params = { abbr_survey, id }

    HttpRequest.fetch<IStatus[]>('/scripts/action_alerts/action_alert/updateActionItemStatus', { body, method, params })
      .then((statuses) => {
        newStatus.actionTaken = ''
        newStatus.resolutionStatus = 0

        this.updateModalState(false)
        this.setState({ statuses, newStatus })

        //NOTE: pull the latest status to update the header
        const lastStatus = statuses[0]
        //Refresh Status in parent window
        try {

          if (window.opener)
            window.opener.postMessage('refreshStatusSection', location.origin)
          const updateList = new CustomEvent('updateCoachingFormHeader', { detail: { lastStatus } });
          window.dispatchEvent(updateList);
          const refresh = new CustomEvent('refreshStatusSection', { detail: { lastStatus } });
          window.dispatchEvent(refresh);
        } catch { /**/ }
      })
  }

  postMessage() {

  }

  render() {
    let sortedStatuses = (this.state.statuses ? Object.assign(this.state.statuses) : [])
    // sortedStatuses.sort(function(a, b) {
    //   if (a.date > b.date) return -1
    //   if (a.date < b.date) return 1
    //   return 0
    // })

    sortedStatuses.map((s) => {
      s.date = (new Date(s.date).toLocaleDateString().toLowerCase() !== 'invalid date' ? new Date(s.date).toLocaleDateString().toLowerCase() : '') + ', ' + (new Date(s.date).toLocaleTimeString().toLowerCase() !== 'invalid date' ? new Date(s.date).toLocaleTimeString() : '')
      return s
    })
    return (
      <div className="section" id="notes">
        <div className="row">
          <div className="col s12 catHeadingFont">
            <span> Status/History&nbsp;</span>
            <a href="javascript:void(0)" onClick={() => this.updateModalState(true)}>
              <MaterialIcon icon="add" color="blue" />
            </a>
          </div>
          <div className="col s12" style={{ border: '1px solid lightgrey', minHeight: '100px' }}>
            <table style={{ padding: '15px 5px' }}>
              <thead>
                <tr>
                  <th>Date</th>
                  <th>User</th>
                  <th>Action Taken</th>
                  <th>Status</th>
                </tr>
              </thead>
              {(sortedStatuses && sortedStatuses.length > 0) &&
                <tbody>
                  {sortedStatuses && sortedStatuses.map((status) =>
                    <tr key={status.id}>
                      <td>{status.date}</td>
                      <td>{status.user}</td>
                      <td>{status.actionTaken}</td>
                      <td>{status.resolutionStatus}</td>
                    </tr>
                  )}
                </tbody>
              }
            </table>
          </div>
        </div>

        <Modal open={this.state.openModal}>
          <form onSubmit={(e) => this.addResolutionStatus(e)}>
            <ModalContent>
              <header>
                <h4>Update Status</h4>
              </header>

              <section>
                <div className="input-field">
                  <div className="label">Status</div>
                  <select className="browser-default" required
                    value={this.state.newStatus.resolutionStatus}
                    onChange={(e) => this.updateNewStatus('resolutionStatus', e.target.value)}>
                    {this.state.statusTypes.map((statusType) =>
                      <option key={statusType.id} value={statusType.id}>{statusType.status}</option>
                    )}
                  </select>
                </div>
                <div className="input-field">
                  <textarea className="materialize-textarea" required
                    value={this.state.newStatus.actionTaken}
                    onChange={(e) => this.updateNewStatus('actionTaken', e.target.value)}></textarea>
                  <label className="active">Action Taken</label>
                </div>
              </section>
            </ModalContent>
            <ModalFooter>
              <Button type="submit" color="primary">
                <span>Save</span>
              </Button>
              <Button type="button" color="white" onClick={() => this.updateModalState(false)}>
                <span>Cancel</span>
              </Button>
            </ModalFooter>
          </form>
        </Modal>
      </div>
    )
  }
}
